import { createRoot } from "react-dom/client";
import App from "./App";

import "./../../../../utils/css/self-framework.scss";
import "./style.scss";

import "./../../store";

document.addEventListener("DOMContentLoaded", () => {
  const dom = document.getElementById("vstr_feedbacks");
  if (dom) {
    const root = createRoot(dom);
    root.render(<App />);
  }
});
